import React, { useEffect, useState } from "react";
import * as Survey from "survey-react-ui";
import { useParams } from "react-router-dom";
import { getSurveyStructureByHash, receiveConsensusAnswerADP } from "../../services/http/surveyHttpService";
import {
 
  Box,
  Spinner,
  Text,
} from "@chakra-ui/react";

import { initSurveyService } from "../../services/http/surveyHttpService";
import { useToast } from "@chakra-ui/react";
import { useSession } from "../../SessionContext";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors";
import { useNavigate } from "react-router-dom";
import logout from "../../services/authService";
import Header from "../Header";

import { useTranslation } from "react-i18next";

import $ from "jquery";
import * as SurveyCore from "survey-core";
import "survey-core/defaultV2.min.css";

import { jqueryuidatepicker } from "surveyjs-widgets";
import "jquery-ui-dist/jquery-ui.css";

window["$"] = window["jQuery"] = $;
require("jquery-ui-dist/jquery-ui.js");

jqueryuidatepicker(SurveyCore);

const SurveyConsensusAnswerView = () => {
  const [survey, setSurvey] = useState(null);
  const [responseGetSurveyStructure, setResponseGetSurveyStructure] = useState(null);
  const {t} = useTranslation();
  const toast = useToast();
  const { clearSessionData} = useSession();
  const navigate = useNavigate();
  let axiosInstance = createAxiosInstance(async (axiosInstance)=> {

    logout(t, clearSessionData,navigate,toast,axiosInstance)
    
  });

  initSurveyService(t, toast, axiosInstance)


const {  sha_key } = useParams();


  useEffect(() => {
    




  getSurveyStructureByHash(sha_key).then(res => {


   
      if(res && res.message && res.message.survey_structure) {
     

        
      const wrapHtmlInPanels = (survey) => {
        if (!survey || !survey.pages) return survey; // Se survey è null o non ha pagine, non fare nulla
    
        return {
            ...survey,
            pages: survey.pages.map(page => ({
                ...page,
                elements: page.elements.map(element =>
                    element.type === "html"
                        ? {
                            type: "panel",
                            name: `${element.name}-panel`,
                            title: element.title || "",
                            elements: [element]  // Wrap HTML inside panel
                        }
                        : element
                )
            }))
        };
    };

        const surveyModel = new Survey.Model(wrapHtmlInPanels(res.message.survey_structure));
        surveyModel.onValueChanged.add(function(sender, options) {
          const dropdownNames = ["skilled_in1", "skilled_in2", "skilled_in3"];
      
          // Recupera tutti i valori selezionati
          let selectedValues = dropdownNames.map(name => sender.getValue(name)).filter(val => val);
      
          // Aggiorna le scelte di ogni dropdown
          dropdownNames.forEach(name => {
              let question = sender.getQuestionByName(name);
              if (question) {
                  let allChoices = [
                    "Redditi, disuguaglianza e povertà",
                    "Tassazione",
                    "Lavoro",
                    "Conti pubblici",
                    "Imprese, concorrenza e regolamentazione",
                    "Energia e ambiente",
                    "Inflazione e politica monetaria",
                    "Infrastrutture e trasporti",
                    "Demografia e immigrazione",
                    "Istituzioni",
                    "Politiche commerciali",
                    "Divari territoriali",
                    "Istruzione e ricerca",
                    "Sanità",
                    "Pensioni",
                    "Banche, assicurazioni e mercati finanziari"
                  ];
      
                  // Filtra choices: mantiene la scelta attuale e rimuove quelle già selezionate altrove
                  question.choices = allChoices.filter(choice => 
                      choice === sender.getValue(name) || !selectedValues.includes(choice)
                  );
      
                  sender.render();
  
              }
          });
      });
  
        


        setResponseGetSurveyStructure(res.message)
        setSurvey(surveyModel);
      }
      
    })
    
   
    
  },[]);

  // Resetta la pagina iniziale ogni volta che il modale si apre
  
  function isValidDate(dateString) {
    // Controlla che la data sia nel formato "dd-MM-yyyy"
    const regex = /^\d{2}-\d{2}-\d{4}$/;
    
    if (!regex.test(dateString)) {
        return false; // Il formato non corrisponde
    }

    // Dividi la stringa in giorno, mese e anno
    const [day, month, year] = dateString.split('-').map(Number);

    // Crea un oggetto Date per controllare che la data sia valida
    const date = new Date(year, month - 1, day); // Mese è zero-indicizzato

    // Verifica che la data creata corrisponda alla data originale
    return date.getDate() === day && date.getMonth() + 1 === month && date.getFullYear() === year;
}



  return (
   <>
          {survey ? (
            <Box
              h="100vh"
              p={4}
              bg="gray.50"
              rounded="md"
              shadow="md"
              overflowY="auto"
            >


{!sessionStorage.getItem("username") && (
  <Header isVisibleMenuLang={false} />
)}

              
              <Survey.Survey model={survey} onComplete={(surveyRes)=>{
          

                let body = {
                  expert_id: parseInt(responseGetSurveyStructure.expert_id),
                  id_survey_info : responseGetSurveyStructure.id_survey_info,
                  sha_key: sha_key,  
                  json_answer:surveyRes.data};
                  
                  const date = new Date(body.json_answer.birth_date);
                  const formattedDate = `${date.getUTCDate().toString().padStart(2, '0')}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCFullYear()}`;
                  body.json_answer.birth_date = formattedDate;
                  
                   
             
                  

                  
                receiveConsensusAnswerADP(t,body ).then(res => {
                  console.log(res)

                  navigate("/home?hideHeader=true&hideNavbar=true")

                  })

                
              }} />
            </Box>
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="80vh"
              p={5}
            >
              <Spinner size="lg" color="blue.500" />
              <Text ml={3} fontSize="lg" color="gray.600">
                Loading survey...
              </Text>
            </Box>
          )}
     </>
  );
};

export default SurveyConsensusAnswerView;
